import type { MaybeRef } from '@vueuse/core'
import { useQuery } from '@tanstack/vue-query'
import { toRef } from 'vue'
import { queryKeys } from '~/queryClient'
import { getPartnerSolfacilPlusInfo } from '~/services-v2/solfacil-plus-api/solfacil-plus-api'

export function useSolfacilPlusInfo(partnerId: MaybeRef<string>) {
  const partnerIdRef = toRef(partnerId)
  const queryKey = computed(() => queryKeys.SOLFACILPLUS.INFO(partnerIdRef.value))

  const query = useQuery({
    queryKey,
    queryFn: () => getPartnerSolfacilPlusInfo(partnerIdRef.value),
    staleTime: 1000 * 60 * 1,
    retry: 3,
    retryDelay: 1000,
    enabled: computed(() => !!partnerIdRef.value),
  })

  return query
}

export type SolfacilPlusInfo = ReturnType<typeof useSolfacilPlusInfo>['data']['value']
